






import {StoreNamespace} from "@/globals/StoreNamespaceGlobal";
import Component from 'vue-class-component'
import {Action, Mutation} from "vuex-class";
import FeedbackComponent from '../../base/FeedbackComponent'

@Component({
  components: {}
})
export default class LoginViaSsoComponent extends FeedbackComponent {

  @Action('resetStore') resetStore: any
  @Action('getManagingCompanyConfig', StoreNamespace.AUTHENTICATION) getManagingCompanyConfig: any

  @Mutation('setUserDetails', StoreNamespace.AUTHENTICATION) setUserDetails: any
  @Mutation('setTokens', StoreNamespace.AUTHORIZATION) setTokens: any
  @Mutation('setClientErrorsIndication', StoreNamespace.AUTHENTICATION) setClientErrorsIndication: any
  @Mutation('setMngCompanyName', StoreNamespace.AUTHENTICATION) setMngCompanyName: any
  @Mutation('setCustomerDetails', StoreNamespace.AUTHENTICATION) setCustomerDetails: any
  @Mutation('setOprEntityKey', StoreNamespace.AUTHENTICATION) setOprEntityKey: any

  private companyUrl: String = ''
  private passwordExpired: any;

  mounted() {
    this.resetStore()
    this.handleRedirect();
  }


  onSuccess(data?: any, requestName?: string, message?: string, success?: boolean): void {
    if (requestName === "getManagingCompanyConfig") {

      this.setMngCompanyName(this.companyUrl)
      this.setCustomerDetails(data)

      // @ts-ignore
      $('body').addClass(this.companyUrl)

      this.setOprEntityKey(data.oprEntityKey)

      setTimeout(() => {
        if (this.passwordExpired) {
          this.$router.push({name: 'expired'})
        } else {
          this.$router.push({name: 'lobby'})
        }
      }, 100)
    }
  }

  handleRedirect() {
    // Get data from URL parameters
    const dataParam = this.$route.query.data as string;

    if (dataParam) {
      // Decode the URL-encoded data
      const decodedData = decodeURIComponent(dataParam);
      try {
        const dataJson = JSON.parse(decodedData);
        const data = dataJson.body

        this.setClientErrorsIndication(data.clientErrorIndication)
        this.setUserDetails(data.userDetails)
        this.setTokens({
          accessToken: data.accessToken,
          refreshToken: data.refreshToken
        })

        this.companyUrl = data.companyRouting
        this.passwordExpired = data.userDetails.passwordExpired
        this.getManagingCompanyConfig({
          pathVariable: data.companyRouting,
          requestorCallback: this
        })

      } catch (error) {
        console.error('Error parsing JSON data:', error);
      }
    } else {
      console.warn('No data received in URL parameters');
    }
  }
}
